<template>
  <div
    class="dashboard-wrap"
    :style="'background-image:url('+require('../../../assets/images/dashboard/'+bgcdash+'.png')+');background-size:cover'"
  >
    <div class="header-wrap" :data-theme="$store.state.dataTheme">
      <div class="txt-title">
        <span>你好，admin，欢迎登录</span>
      </div>
      <div>
        <button @click="loginout()">退出</button>
      </div>
    </div>
    <div class="inform-wrap">
      <div class="inform-wrapbox">
        <img src="@/assets/images/home/logo.png" class="inform-wrapimg" alt />
        <div class="inform-wraphead">
          <div class="inform-wrapli">
            <div>{{biaoTi}}</div>
            <div class="inform-wrapheadright">后台管理</div>
          </div>
          <div class="inform-wraplito">
            <div
              style="font-size: 16px;font-weight:500;"
            >{{englishBiaoTi}}</div>
            <div class="inform-wrapheadright" style="font-size:12px">Background management</div>
          </div>
        </div>
      </div>
    </div>
    <ul class="box-wrap">
      <li class="box-item" v-for="item in funcList" :key="item.txt" @click="gobackStage()">
        <div class="imgli">
          <img :src="item.img" alt="icon" :draggable="false" />
        </div>

        <div class="textbox">
          <div class="txt">{{item.title}}</div>
          <div class="rihet">{{item.txt}}</div>
        </div>

        <!-- <div class="o-0bscuration" v-if="item.jurisdiction">
          <div class="info">
            <img src="@/assets/images/dashboard/u70.svg" alt="oo" :draggable="false" />
            无访问权
          </div>
        </div>-->
      </li>
    </ul>
  </div>
</template>

<script>
import { removeInfo, getInfo } from '@/utils/auth';
export default {
  components: {},
  data() {
    return {
      // bgcdash: require('../../../assets/images/dashboard/bgcdash.png'),
      biaoTi: localStorage.getItem('biaoti'),
      englishBiaoTi: localStorage.getItem('englishBiaoTi'),
      bgcdash: 'bgcdash',
      funcList: [
        {
          title: '门户管理',
          txt: 'Portal management',
          img: require('@/assets/images/dashboard/portal.png'),
        },
        {
          title: '资源管理',
          txt: 'Resource management',
          img: require('@/assets/images/dashboard/explorer.png'),
        },
        {
          title: '微警校',
          txt: 'Micro police academy',
          img: require('@/assets/images/dashboard/policeTraining.png'),
        },
        {
          title: '考试管理',
          txt: 'Examination management',
          img: require('@/assets/images/dashboard/examination.png'),
        },
        {
          title: '调训管理',
          txt: 'Training management',
          img: require('@/assets/images/dashboard/remedium.png'),
        },
        {
          title: '问卷测评',
          txt: 'Questionnaire evaluation',
          img: require('@/assets/images/dashboard/questionnaire.png'),
        },
        {
          title: '教官库',
          txt: 'Instructors library',
          img: require('@/assets/images/dashboard/instructor.png'),
        },
        {
          title: '电子证书',
          txt: 'Electronic Certificate',
          img: require('@/assets/images/dashboard/electroniccertificate.png'),
        },
        {
          title: '数据分析',
          txt: 'Data analysis',
          img: require('@/assets/images/dashboard/dataanalysis.png'),
        },
        {
          title: '系统管理',
          txt: 'System management',
          img: require('@/assets/images/dashboard/systemmanagement.png'),
          jurisdiction: false,
        },
      ],
    };
  },
  methods: {
    // 退出功能，清楚缓存
    loginout() {
      var _this = this;
      _this.$confirm('确认退出吗?', '提示', {}).then(() => {
        _this.$store.commit('SET_TOKENS', '');
        _this.$store.commit('SET_INFOS', '');
        removeInfo('infos');
        removeInfo('tokens');
        removeInfo('IDS');
        _this.$router.push('/home');
      });
    },
    // 跳转后台
    gobackStage() {
      let toke = getInfo('tokens');
      // http://121.12.125.214:2369   http://localhost:8086
      window.open('http://121.12.125.214:2369/login?token=' + toke);
    },
    logOut() {
      this.$confirm('确认退出该用户？')
        .then((_) => {
          this.$router.replace({ name: 'home' });
        })
        .catch((_) => {});
    },
  },
};
</script>

<style lang="scss" scoped>
* {
  box-sizing: border-box;
}
.dashboard-wrap {
  width: 100%;
  height: 850px;
  // height: calc(100%);

  .header-wrap {
    height: 68px;
    display: flex;
    align-items: center;
    @include themeify {
      background: themed('color-primary');
      border-top-color: themed('color-border-lighter');
    }
    .txt-title {
      width: 1200px;
      margin: 0 auto;
      text-align: right;
      font-style: normal;
      font-size: 14px;
      line-height: 28px;
      color: #fff;
    }
  }

  .inform-wrap {
    width: 1200px;
    margin: 0 auto;
    margin-top: 65px;
    display: flex;
    justify-content: center;
    .inform-wrapbox {
      display: flex;
      align-items: center;
      .inform-wrapimg {
        height: 70px;
        width: 70px;
      }
      .inform-wraphead {
        flex: 1;
        color: #333;
        margin-left: 32px;

        .inform-wrapli {
          display: flex;
          font-size: 36px;
          font-weight: bold;

          text-shadow: 0px 5px 4px rgba(255, 255, 255, 0.38);
          .inform-wrapheadright {
            display: inline-block;
            margin-left: 16px;
          }
        }
        .inform-wraplito {
          display: flex;
          margin-top: 10px;
          .inform-wrapheadright {
            display: inline-block;
            margin-left: 18px;
            font-size: 12px;
            line-height: 18px;
          }
        }
      }
    }
  }

  .box-wrap {
    width: 1200px;
    margin: 0 auto;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    border-style: none;
    padding: 0;
    list-style: none;
    padding: 0 50px;
    margin-top: 100px;
    .box-item {
      margin: 0 2.5% 20px 0;
      width: 198px;
      height: 198px;
      background: #f8fafc;
      box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.16);
      opacity: 1;
      border-radius: 6px;
      &:nth-child(5n) {
        margin-right: 0;
      }

      .imgli {
        padding: 16px 0 10px 0;

        img {
          width: 100px;
          height: 100px;
          display: block;
          margin: 0 auto;
        }
      }
      .textbox {
        box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.16);
        opacity: 1;
        border-radius: 0px 0px 6px 6px;
        background-color: #efefef;
        height: 72px;
        padding-top: 4px;
        .txt {
          display: block;
          text-align: center;
          font-weight: 400;
          font-style: normal;
          font-size: 19px;
          line-height: 33px;
        }
        .rihet {
          text-align: center;
          font-weight: 400;
          font-style: normal;
          font-size: 14px;
          line-height: 24px;
        }
      }
    }
  }
}
</style>
